import {
  FloorPlannerActions,
  FloorPlannerActionTypes,
} from "../actions/floorplanner.action";

export interface FloorPlannerState {
  projects: any[];
  projectsLoading: boolean;
  projectsError: boolean;

  templates: any[];
  templatesLoading: boolean;
  templatesError: boolean;

  template: any;
  templateLoading: boolean;
  templateError: boolean;

  projectDownload: any;
  projectDownloadLoading: boolean;
  projectDownloadError: boolean;

  projectExport: any;
  projectExportLoading: boolean;
  projectExportError: boolean;

  exportFml: any;
  exportFmlLoading: boolean;
  exportFmlError: boolean;

  exportTwoD: any;
  exportTwoDLoading: boolean;
  exportTwoDError: boolean;

  exportThreeD: any;
  exportThreeDLoading: boolean;
  exportThreeDError: boolean;

  project: any;
  projectLoading: boolean;
  projectError: boolean;

  createProject: any;
  createProjectLoading: boolean;
  createProjectError: boolean;

  productsList: any;
  productsListLoading: boolean;
  productsListError: boolean;

  createDesign: any;
  createDesignLoading: boolean;
  createDesignError: boolean;

  design: any;
  designLoading: boolean;
  designError: boolean;

  key: any;
  keyLoading: boolean;
  keyError: boolean;

  projectProducts: any;
  projectProductsLoading: boolean;
  projectProductsError: boolean;
}

export const initialState: FloorPlannerState = {
  projects: [],
  projectsLoading: false,
  projectsError: false,

  templates: [],
  templatesLoading: false,
  templatesError: false,

  template: null,
  templateLoading: false,
  templateError: false,

  projectDownload: null,
  projectDownloadLoading: false,
  projectDownloadError: false,

  projectExport: null,
  projectExportLoading: false,
  projectExportError: false,

  exportFml: null,
  exportFmlLoading: false,
  exportFmlError: false,

  exportTwoD: null,
  exportTwoDLoading: false,
  exportTwoDError: false,

  exportThreeD: null,
  exportThreeDLoading: false,
  exportThreeDError: false,

  project: null,
  projectLoading: false,
  projectError: false,

  createProject: null,
  createProjectLoading: false,
  createProjectError: false,

  productsList: null,
  productsListLoading: false,
  productsListError: false,

  createDesign: null,
  createDesignLoading: false,
  createDesignError: false,

  design: null,
  designLoading: false,
  designError: false,

  key: null,
  keyLoading: false,
  keyError: false,

  projectProducts: null,
  projectProductsLoading: false,
  projectProductsError: false,
};

export function reducer(
  state = initialState,
  action: FloorPlannerActions
): FloorPlannerState {
  switch (action.type) {
    case FloorPlannerActionTypes.GET_PROJECT_LIST: {
      return {
        ...state,
        projectsLoading: true,
        projectsError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PROJECT_LIST_SUCCESS: {
      return {
        ...state,
        projects: action.payload,
        projectsLoading: false,
        projectsError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PROJECT_LIST_FAILURE: {
      return {
        ...state,
        projectsLoading: false,
        projectsError: true,
      };
    }

    case FloorPlannerActionTypes.CLEAR_PROJECT_LIST: {
      return {
        ...state,
        projects: [],
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE_LIST: {
      return {
        ...state,
        templatesLoading: true,
        templatesError: false,
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE_LIST_SUCCESS: {
      return {
        ...state,
        templates: action.payload,
        templatesLoading: false,
        templatesError: false,
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE_LIST_FAILURE: {
      return {
        ...state,
        templatesLoading: false,
        templatesError: true,
      };
    }

    case FloorPlannerActionTypes.CLEAR_TEMPLATE_LIST: {
      return {
        ...state,
        templates: [],
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE: {
      return {
        ...state,
        templateLoading: true,
        templateError: false,
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE_SUCCESS: {
      return {
        ...state,
        template: action.payload,
        templateLoading: false,
        templateError: false,
      };
    }

    case FloorPlannerActionTypes.GET_TEMPLATE_FAILURE: {
      return {
        ...state,
        templateLoading: false,
        templateError: true,
      };
    }

    case FloorPlannerActionTypes.PROJECT_DOWNLOAD: {
      return {
        ...state,
        projectDownloadLoading: true,
        projectDownloadError: false,
      };
    }

    case FloorPlannerActionTypes.PROJECT_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        projectDownload: action.payload,
        projectDownloadLoading: false,
        projectDownloadError: false,
      };
    }

    case FloorPlannerActionTypes.PROJECT_DOWNLOAD_FAILURE: {
      return {
        ...state,
        projectDownloadLoading: false,
        projectDownloadError: true,
      };
    }

    case FloorPlannerActionTypes.PROJECT_EXPORT: {
      return {
        ...state,
        projectDownloadLoading: true,
        projectDownloadError: false,
      };
    }

    case FloorPlannerActionTypes.PROJECT_EXPORT_SUCCESS: {
      return {
        ...state,
        projectDownload: action.payload,
        projectDownloadLoading: false,
        projectDownloadError: false,
      };
    }

    case FloorPlannerActionTypes.PROJECT_EXPORT_FAILURE: {
      return {
        ...state,
        projectDownloadLoading: false,
        projectDownloadError: true,
      };
    }

    case FloorPlannerActionTypes.EXPORT_FML: {
      return {
        ...state,
        exportFmlLoading: true,
        exportFmlError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_FML_SUCCESS: {
      return {
        ...state,
        exportFml: action.payload,
        exportFmlLoading: false,
        exportFmlError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_FML_FAILURE: {
      return {
        ...state,
        exportFmlLoading: false,
        exportFmlError: true,
      };
    }

    case FloorPlannerActionTypes.EXPORT_TWO_D: {
      return {
        ...state,
        exportTwoDLoading: true,
        exportTwoDError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_TWO_D_SUCCESS: {
      return {
        ...state,
        exportTwoD: action.payload,
        exportTwoDLoading: false,
        exportTwoDError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_TWO_D_FAILURE: {
      return {
        ...state,
        exportTwoDLoading: false,
        exportTwoDError: true,
      };
    }

    case FloorPlannerActionTypes.EXPORT_THREE_D: {
      return {
        ...state,
        exportThreeDLoading: true,
        exportThreeDError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_THREE_D_SUCCESS: {
      return {
        ...state,
        exportThreeD: action.payload,
        exportThreeDLoading: false,
        exportThreeDError: false,
      };
    }

    case FloorPlannerActionTypes.EXPORT_THREE_D_FAILURE: {
      return {
        ...state,
        exportThreeDLoading: false,
        exportThreeDError: true,
      };
    }

    case FloorPlannerActionTypes.GET_PROJECT: {
      return {
        ...state,
        projectLoading: true,
        projectError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PROJECT_SUCCESS: {
      return {
        ...state,
        project: action.payload,
        projectLoading: false,
        projectError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PROJECT_FAILURE: {
      return {
        ...state,
        projectLoading: false,
        projectError: true,
      };
    }

    case FloorPlannerActionTypes.CREATE_PROJECT: {
      return {
        ...state,
        createProjectLoading: true,
        createProjectError: false,
      };
    }

    case FloorPlannerActionTypes.CREATE_PROJECT_SUCCESS: {
      return {
        ...state,
        createProject: action.payload,
        createProjectLoading: false,
        createProjectError: false,
      };
    }

    case FloorPlannerActionTypes.CREATE_PROJECT_FAILURE: {
      return {
        ...state,
        createProjectLoading: false,
        createProjectError: true,
      };
    }

    case FloorPlannerActionTypes.GET_PRODUCTS: {
      return {
        ...state,
        productsListLoading: true,
        productsListError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        productsList: action.payload,
        productsListLoading: false,
        productsListError: false,
      };
    }

    case FloorPlannerActionTypes.GET_PRODUCTS_FAILURE: {
      return {
        ...state,
        productsListLoading: false,
        productsListError: true,
      };
    }

    case FloorPlannerActionTypes.CREATE_DESIGN: {
      return {
        ...state,
        createDesignLoading: true,
        createDesignError: false,
      };
    }

    case FloorPlannerActionTypes.CREATE_DESIGN_SUCCESS: {
      return {
        ...state,
        createDesign: action.payload,
        createDesignLoading: false,
        createDesignError: false,
      };
    }

    case FloorPlannerActionTypes.CREATE_DESIGN_FAILURE: {
      return {
        ...state,
        createDesignLoading: false,
        createDesignError: true,
      };
    }

    case FloorPlannerActionTypes.GET_DESIGN: {
      return {
        ...state,
        designLoading: true,
        designError: false,
      };
    }

    case FloorPlannerActionTypes.GET_DESIGN_SUCCESS: {
      return {
        ...state,
        design: action.payload,
        designLoading: false,
        designError: false,
      };
    }

    case FloorPlannerActionTypes.GET_DESIGN_FAILURE: {
      return {
        ...state,
        designLoading: false,
        designError: true,
      };
    }

    case FloorPlannerActionTypes.GET_USER_KEY: {
      return {
        ...state,
        keyLoading: true,
        keyError: false,
      };
    }

    case FloorPlannerActionTypes.GET_USER_KEY_SUCCESS: {
      return {
        ...state,
        key: action.payload,
        keyLoading: false,
        keyError: false,
      };
    }

    case FloorPlannerActionTypes.GET_USER_KEY_FAILURE: {
      return {
        ...state,
        keyLoading: false,
        keyError: true,
      };
    }

    case FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS: {
      return {
        ...state,
        projectProductsLoading: true,
        projectProductsError: false,
      };
    }

    case FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS_SUCCESS: {
      return {
        ...state,
        projectProducts: action.payload,
        projectProductsLoading: false,
        projectProductsError: false,
      };
    }

    case FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS_FAILURE: {
      return {
        ...state,
        projectProductsLoading: false,
        projectProductsError: true,
      };
    }

    default:
      return state;
  }
}
